import { Route } from "@angular/router";
import { IFeatureSettings } from "@partners/settings";
import { provideTrackerParams } from "../../config";

export const configRoute = (featureSettings: IFeatureSettings): Partial<Route> => {
  const { path } = featureSettings;
  /**
  we use provideTrackerParams to initialize a background services which send async requests
  to the server to document metadata and/or errors
  example: user navigation (journey) throughout the app and unexpected client-side errors
  */
  const providers = [provideTrackerParams({ screenName: featureSettings.path })];
  return { path, providers };
};

